/**
 * Mirrors backend/src/Evaluation/Template/MarkdownFeature.php
 */
export const MARKDOWN_FEATURES = [
  "heading",
  "paragraph",
  "list",
  "emphasis",
  "link",
  "rule",
] as const

export type MarkdownFeature = (typeof MARKDOWN_FEATURES)[number]
